module.exports = __webpack_public_path__ + "img/betded-logo.77be2107.png";